export const BASE_ROUTE = '/:projectId'
